const data = [
  {
    id: 1,
    image: "/assets/1.jpg",
    title: "Humor przemieszany z ironią, komizm sytuacyjny i słowny",
    desc: "'Klub Pickwicka' to pierwsza powieść Charlesa Dickensa publikowana w odcinkach w latach 1836-1837 opowiadająca o podróży Samuela Pickwicka i jego kompanów: Augusta Snodgrassa, Tracy'ego Tupmana, Nataniela Winkle'go oraz służącego Samuela Wellera po okolicach Londynu.",
    link: "https://pl.wikipedia.org/wiki/Klub_Pickwicka",
  },
  {
    id: 2,
    image: "/assets/2.jpeg",
    title: "Korespondenci z powołania",
    desc: "Panowie podróżują na własny koszt, ale od czasu do czasu przesyłają do Towarzystwa Klubu Pickwicka w Londynie relacje z podróży i poszukiwań terenowych, spostrzeżenia nad obyczajami i charakterem miejscowej ludności, a także opowiadania, wiersze, piosenki powstałe w wyniku brania udziału w miejscowych wydarzeniach.",
    link: "https://eszkola.pl/jezyk-polski/klub-pickwicka-streszczenie-11576.html",
  },
  {
    id: 3,
    image: "/assets/3.jpg",
    title: "Bohaterowie są niezwykle oryginalni i zabawni",
    desc: "Samuel Pickwick - okrąglutki, jowialny, zacny, rozsyłający najsłodsze i najpiękniejsze w świecie uśmiechy bez widocznego powodu, dobroduszny dżentelmen, który chodzi ubrany w trykoty w paski i bada naturę ludzką. Przez swoją dobroć i naiwność popada ciągle w tarapaty.",
    link: "https://www.storytel.com/pl/pl/books/klub-pickwicka-547379",
  },
  {
    id: 4,
    image: "/assets/4.jpg",
    title: "Kompani Pickwicka",
    desc: "August Snodgrass - wybitnie usposobiony poetycko, co przejawia się w jego wypowiedziach i sposobie bycia. Nataniel Winkle - ubiera się w strój myśliwski, ale w czasie polowań nie odnosi zbytnich sukcesów. Tracy Tupman - ognisty, namiętny, przystojny, szczery i wrażliwy na kobiece wdzięki. Samuell Weller - porywczy, zapalczywy i skłonny do bitki na zawołanie.",
    link: "https://www.polskieradio.pl/7/1530/Artykul/2756752,Klub-Pickwicka",
  },
  {
    id: 5,
    image: "/assets/5.jpg",
    title: "Zabawne przygody",
    desc: "W czasie podróży bohaterowie zatrzymują się w kolejnych zajazdach, gdzie jedzą, piją, bawią się i poznają przeróżnych ludzi, a ich liczba jest imponująca, bo sięga prawie trzystu osób. Zabawy i rozmowy urozmaicane są poetyckimi piosenkami, które umieszczone są w tekście. Członkowie Klubu przeżywają uniesienia miłosne, kłopoty finansowe, ...",
    link: "https://cyfroteka.pl/ebooki/Klub_Pickwicka-ebook/p14434i36170",
  },
  {
    id: 6,
    image: "/assets/6.jpg",
    title: "Dickens w barwny sposób odmalowuje naturę ludzką",
    desc: "Krytykuje prawo i sądownictwo w XIX-wiecznej Anglii, które chroni przestępców, kombinatorów i wszelkiej maści oszustów. Krytyka jest ostra, ale ukryta subtelnie pod płaszczykiem zabawnych sytuacji, które przeżywają bohaterowie. Humor przemieszany z ironią, komizm sytuacyjny i słowny, ...",
    link: "https://pl.wikisource.org/wiki/Klub_Pickwicka",
  },
];
export default data;
